import { createApp } from 'vue'
import App from './app.vue'
// import './registerServiceWorker'
import router from './router'
import axios from "axios";
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import { createPinia } from 'pinia'
import {} from 'keycloak-js';
import { keycloakPlugin } from '@/config/keycloak'

const app = createApp(App).use(createPinia()).use(Quasar, quasarUserOptions).use(router, axios).use(keycloakPlugin)
app.mount('#app')
export { app }
